import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { ILogOS, ILogOSCreateParams, ILogOSPost, IPaginatedLogOS } from "@app/interface/os-logs";
import { environment } from "@env/environment";
import { catchError, first, firstValueFrom, Observable, of, switchMap } from "rxjs";
import { ApiPaginatedResponse, ApiPaginatedRoLogsQueryParams, PaginationService } from "./pagination.service";
import { API_ERRORS } from "@app/shared/lists/errors";

@Injectable({
  providedIn: 'root'
})
export class RoLogsService {

  private _baseUrl = `${environment.mkgoURL}/api/v1/log-os`;
  
  private _http = inject(HttpClient);
  private _dataService = inject(DataService);
  
  async create(data: ILogOSCreateParams) {
    const { actionType, osId, statusInTheLogRecord, invoicesRelated, reason, updatedFields } = data;

    const log: ILogOSPost = {
      actionType,
      osId,
      statusInTheLogRecord,
      userId: this._dataService.user._id ?? this._dataService.user.id,
      invoicesRelated,
      reason,
      updatedFields
    };

    try {
      const options = await firstValueFrom(this._dataService.httpOptions(false));
  
      return await firstValueFrom(this._http.post(this._baseUrl, log, options));
    } catch (error) {
      console.error(error);
      return;
    }
  }

  getPaginated(queryParams: ApiPaginatedRoLogsQueryParams): Observable<ApiPaginatedResponse<IPaginatedLogOS>> {
    const params = PaginationService.getParams(queryParams);
    const url = `${this._baseUrl}/pages`;

    return this._dataService.httpOptions(false, params).pipe(
      switchMap(options => this._http.get<ApiPaginatedResponse<IPaginatedLogOS>>(url, options)),
      first(),
      catchError(err => {
        if (err.error.error === API_ERRORS.notFound) {
          return of({
            docs: [],
            hasNextPage: false,
            hasPrevPage: false,
            limit: 0,
            nextPage: null,
            page: 0,
            pagingCounter: 0,
            prevPage: null,
            totalDocs: 0,
            totalPages: 0
          })
        } else {
          throw err;
        }
      })
    )
  }
}